/* Magix mark: the M monogram as liquid chrome. When it scrolls into view it
   spins in from the left edge of the screen, bouncing across the section to its
   place, slows to a stop at 3.5s, then stays put and comes alive: it flexes,
   squashes, stretches, leans and moulds like a liquid-chrome character.
   Draws into #markLiquid. */
(function () {
  var canvas = document.getElementById('markLiquid');
  if (!canvas) return;
  var gl = canvas.getContext('webgl', { premultipliedAlpha: true, antialias: false, alpha: true });
  if (!gl) return;

  /* The build takes a moment, so it waits for an idle gap after the page loads */
  function init() {

  /* ---- Signed distance field of the monogram, built once from its outline ---- */
  var M_PATH = 'M1728 63L1716 51L1680 31L1656 23L1639 22L1628 18L1619 18L1608 22L1591 22L1563 31L1547 39L1536 49L1515 63L1423 155L1421 160L1391 191L1389 196L1367 219L1365 224L1343 247L1341 252L1329 263L1313 288L1299 303L1297 308L1283 323L1281 328L1263 347L1257 360L1243 375L1233 392L1223 403L1199 439L1185 464L1163 491L1157 504L1127 547L1117 568L1083 619L1069 648L1064 654L1060 665L1039 695L1031 712L1026 717L1022 718L1014 717L1010 713L1009 695L1017 668L1017 655L1025 628L1025 611L1029 600L1029 575L1033 564L1033 547L1037 536L1037 523L1041 512L1041 499L1045 488L1045 467L1049 456L1049 427L1053 416L1053 399L1057 388L1057 363L1061 352L1061 319L1065 308L1065 259L1061 248L1060 227L1043 182L1026 159L1004 139L992 131L960 115L927 105L916 99L903 98L892 94L879 94L868 90L839 90L828 86L711 86L700 90L667 90L656 94L639 94L628 98L615 98L604 102L591 102L528 118L515 119L500 125L471 131L460 137L439 143L420 153L401 157L356 181L347 183L331 191L324 197L303 207L292 217L279 223L255 239L240 253L223 263L151 335L149 340L115 383L87 439L79 463L78 472L74 483L74 508L70 519L70 536L74 547L74 564L77 571L79 584L91 612L101 623L103 628L131 656L143 664L175 680L187 684L196 685L207 689L244 689L255 693L264 693L275 689L284 689L291 686L304 684L328 676L356 660L368 643L368 632L360 623L355 621L350 616L330 584L321 552L321 535L317 524L317 503L321 492L321 483L325 472L326 459L334 435L350 403L381 359L435 306L468 284L479 274L515 254L524 252L567 230L576 228L587 222L600 220L615 214L624 213L635 209L644 209L675 201L696 201L707 197L784 197L795 201L818 201L821 202L826 209L826 215L823 222L803 243L801 248L783 267L781 272L771 283L755 307L749 320L743 327L737 340L719 363L677 448L671 455L661 476L655 483L649 496L643 503L629 532L623 539L617 556L607 571L585 616L567 643L557 664L539 691L525 720L511 739L505 752L473 800L463 811L453 828L423 863L421 868L395 899L393 904L363 935L361 940L336 965L331 967L304 993L299 995L276 1013L263 1019L257 1024L247 1027L228 1037L192 1049L135 1050L128 1047L115 1045L104 1039L95 1037L75 1026L56 1027L47 1035L39 1047L23 1083L22 1108L19 1115L19 1124L22 1131L22 1144L29 1163L31 1176L47 1204L68 1228L91 1248L103 1256L143 1276L152 1277L179 1285L232 1285L243 1281L252 1281L259 1278L272 1277L288 1272L299 1266L308 1264L348 1244L359 1234L372 1228L411 1194L416 1192L432 1176L434 1171L464 1140L466 1135L492 1104L502 1087L512 1076L536 1040L566 987L584 963L586 955L614 899L620 892L626 879L632 871L634 863L664 804L666 795L675 781L678 771L704 720L706 711L712 700L722 671L764 584L766 575L792 520L794 511L798 503L808 491L814 471L830 439L836 432L840 423L845 418L849 417L857 418L861 422L862 440L858 451L858 460L854 471L853 484L846 503L846 520L838 551L838 564L826 603L826 612L822 623L822 640L810 687L810 696L806 707L806 720L802 731L802 740L798 751L798 760L794 771L794 780L786 807L786 820L782 831L782 848L778 859L778 872L766 919L766 932L762 943L762 956L758 967L758 984L754 995L754 1008L750 1019L750 1036L746 1047L746 1064L742 1075L742 1112L747 1128L759 1152L779 1172L790 1179L803 1184L812 1185L823 1189L836 1189L843 1192L852 1192L859 1189L872 1189L879 1186L892 1184L903 1178L911 1176L930 1165L936 1160L952 1136L958 1120L964 1112L972 1096L974 1087L992 1052L994 1043L1008 1016L1010 1007L1022 983L1035 965L1042 943L1062 903L1080 876L1098 839L1104 832L1122 795L1128 788L1135 770L1148 752L1158 731L1164 724L1182 691L1196 672L1202 659L1216 640L1222 627L1252 584L1258 571L1268 560L1302 507L1324 480L1334 463L1352 440L1360 427L1362 417L1370 412L1381 400L1388 397L1397 398L1401 402L1401 416L1395 427L1393 440L1379 467L1377 480L1359 515L1353 540L1327 599L1313 648L1307 659L1301 680L1295 691L1287 715L1285 728L1279 739L1267 775L1266 788L1230 927L1230 940L1226 951L1226 980L1222 991L1222 1064L1226 1075L1226 1088L1230 1099L1230 1112L1243 1147L1249 1155L1255 1168L1265 1179L1267 1184L1295 1212L1328 1232L1363 1244L1412 1245L1423 1241L1436 1241L1443 1238L1456 1236L1467 1230L1476 1228L1490 1219L1500 1216L1524 1204L1535 1194L1540 1192L1604 1128L1606 1123L1632 1096L1634 1091L1660 1060L1686 1019L1696 1008L1702 995L1723 965L1729 948L1728 919L1724 911L1714 901L1707 898L1691 898L1679 903L1651 935L1633 968L1619 983L1609 1000L1591 1019L1589 1024L1560 1053L1524 1073L1484 1073L1466 1056L1454 1028L1453 1003L1449 992L1449 971L1453 960L1453 927L1457 916L1457 895L1461 884L1461 871L1469 844L1469 835L1472 828L1490 751L1504 708L1510 679L1526 631L1532 620L1562 527L1568 516L1590 451L1600 432L1602 423L1608 412L1614 391L1620 380L1630 351L1640 332L1642 323L1652 304L1654 295L1664 276L1666 267L1688 224L1690 216L1695 209L1698 199L1708 180L1710 171L1732 128L1737 112L1737 83Z';
  var VB_W = 1754, VB_H = 1302;
  var N = 1024, SPAN = 2.4;          /* texture covers [-1.2, 1.2] in object units */
  var RANGE = 48;                   /* distance range in texels stored either side */
  var fit = (N * 0.86) / VB_W;      /* letter width ~86% of the texture */
  var ox = (N - VB_W * fit) / 2, oy = (N - VB_H * fit) / 2;

  /* Outline as a polygon in texel units, lightly smoothed so the traced
     outline's tiny steps don't show up as ripples in the chrome */
  var nums = M_PATH.match(/-?[\d.]+/g).map(Number), P = [];
  for (var i = 0; i + 1 < nums.length; i += 2) P.push([ox + nums[i] * fit, oy + nums[i + 1] * fit]);
  var last = P[P.length - 1];
  if (Math.abs(last[0] - P[0][0]) < 1e-6 && Math.abs(last[1] - P[0][1]) < 1e-6) P.pop();
  var NP = P.length;
  for (var it = 0; it < 2; it++) {
    var Q = [];
    for (i = 0; i < NP; i++) {
      var a0 = P[(i - 1 + NP) % NP], a1 = P[i], a2 = P[(i + 1) % NP];
      Q.push([0.25 * a0[0] + 0.5 * a1[0] + 0.25 * a2[0], 0.25 * a0[1] + 0.5 * a1[1] + 0.25 * a2[1]]);
    }
    P = Q;
  }

  /* Inside test per texel centre: exact even-odd scanline fill */
  var inside = new Uint8Array(N * N), xs = [];
  for (var y = 0; y < N; y++) {
    var cy = y + 0.5; xs.length = 0;
    for (i = 0; i < NP; i++) {
      var p0 = P[i], p1 = P[(i + 1) % NP];
      if ((p0[1] <= cy) !== (p1[1] <= cy)) xs.push(p0[0] + (cy - p0[1]) / (p1[1] - p0[1]) * (p1[0] - p0[0]));
    }
    xs.sort(function (m, n) { return m - n; });
    for (var j = 0; j + 1 < xs.length; j += 2) {
      var xa = Math.max(0, Math.ceil(xs[j] - 0.5)), xb = Math.min(N - 1, Math.floor(xs[j + 1] - 0.5));
      for (var x = xa; x <= xb; x++) inside[y * N + x] = 1;
    }
  }

  /* Exact distance to the outline for every texel within RANGE of it */
  var BAND = RANGE + 1, dist = new Float32Array(N * N).fill(BAND * BAND);
  for (i = 0; i < NP; i++) {
    var A = P[i], B = P[(i + 1) % NP];
    var ex = B[0] - A[0], ey = B[1] - A[1], ll = ex * ex + ey * ey || 1e-9;
    var x0 = Math.max(0, Math.floor(Math.min(A[0], B[0]) - BAND)), x1 = Math.min(N - 1, Math.ceil(Math.max(A[0], B[0]) + BAND));
    var y0 = Math.max(0, Math.floor(Math.min(A[1], B[1]) - BAND)), y1 = Math.min(N - 1, Math.ceil(Math.max(A[1], B[1]) + BAND));
    for (y = y0; y <= y1; y++) {
      var py = y + 0.5 - A[1], row = y * N;
      for (x = x0; x <= x1; x++) {
        var px = x + 0.5 - A[0];
        var h = (px * ex + py * ey) / ll; h = h < 0 ? 0 : h > 1 ? 1 : h;
        var qx = px - ex * h, qy = py - ey * h, dd = qx * qx + qy * qy;
        if (dd < dist[row + x]) dist[row + x] = dd;
      }
    }
  }
  /* Stored as half floats where supported (smooth chrome); 8-bit otherwise */
  var hf = gl.getExtension('OES_texture_half_float'), hfl = gl.getExtension('OES_texture_half_float_linear');
  var useHalf = !!(hf && hfl);
  var f32 = new Float32Array(1), u32 = new Uint32Array(f32.buffer);
  function toHalf(v) {
    f32[0] = v; var x = u32[0];
    var s = (x >>> 16) & 0x8000, e = ((x >>> 23) & 0xff) - 112, m = x & 0x7fffff;
    if (e <= 0) return s; if (e >= 31) return s | 0x7c00;
    return s | (e << 10) | (m >>> 13);
  }
  var raw = new Float32Array(N * N);
  for (i = 0; i < N * N; i++) raw[i] = inside[i] ? -Math.sqrt(dist[i]) : Math.sqrt(dist[i]);   /* + outside, - inside */
  var sdf = useHalf ? new Uint16Array(N * N) : new Uint8Array(N * N);
  for (i = 0; i < N * N; i++) {
    var sd = Math.max(-1, Math.min(1, raw[i] / RANGE));
    sdf[i] = useHalf ? toHalf(sd) : Math.round(127.5 + sd * 127.5);
  }

  /* The letter's lowest points: its base, used as the pivot for squash and lean */
  var low = [];
  for (var x = 0; x < N; x++) {
    var yb = -1;
    for (var y = N - 1; y >= 0; y--) if (inside[y * N + x]) { yb = y; break; }
    low.push(yb);
  }
  var tips = [];
  for (x = 12; x < N - 12; x++) {
    var yv = low[x]; if (yv < 0) continue;
    var isMin = true;
    for (var dx = -28; dx <= 28; dx++) { var o = low[x + dx] === undefined ? -1 : low[x + dx]; if (o > yv) { isMin = false; break; } }
    if (isMin && (!tips.length || x - tips[tips.length - 1][0] > 60)) tips.push([x, yv]);
  }
  tips.sort(function (a, b) { return b[1] - a[1]; });
  tips = tips.slice(0, 4);
  var FOOT = tips.length ? (0.5 - tips[0][1] / N) * SPAN : -0.7;

  var VS = 'attribute vec2 a; void main(){ gl_Position = vec4(a, 0.0, 1.0); }';
  var FS = [
    'precision highp float;',
    'uniform vec2 uRes, uEnc; uniform float uTime, uAng, uAngVel, uTiltX, uBob, uS, uBend, uTwist, uMould; uniform sampler2D uSdf;',
    'const float FOOT = ' + FOOT.toFixed(4) + ';',
    'const float SPAN = ' + SPAN.toFixed(3) + ', RANGE = ' + (RANGE / N * SPAN).toFixed(5) + ';',
    'const float T = 0.11, R = 0.035;',
    'float letter2(vec2 p){',
    '  vec2 uv = vec2(p.x / SPAN + 0.5, 0.5 - p.y / SPAN);',
    '  vec2 q = abs(uv - 0.5) - 0.5;',
    '  float outside = length(max(q, 0.0)) * SPAN;',
    '  float d = (texture2D(uSdf, clamp(uv, 0.002, 0.998)).r - uEnc.x) * uEnc.y * RANGE;',
    '  return d + outside;',
    '}',
    'float map(vec3 p){',
    /* character body: undo twist, lean and squash/stretch (pivoting on its base) */
    '  float yb = p.y - FOOT;',
    '  float ta = -uTwist * yb; float ct = cos(ta), st = sin(ta);',
    '  p.xz = mat2(ct, st, -st, ct) * p.xz;',
    '  p.x += uBend * yb * yb;',
    '  float rs = sqrt(uS);',
    '  p = vec3(p.x * rs, FOOT + yb / uS, p.z * rs);',
    '  float d2 = letter2(p.xy);',
    /* moulding: slow liquid bulges rolling through the metal */
    '  d2 -= uMould * sin(p.x * 4.7 + uTime * 2.3) * sin(p.y * 3.9 - uTime * 1.8) * (0.6 + 0.4 * sin(p.x * 2.1 - p.y * 2.7 + uTime * 1.1));',
    '  vec2 w = vec2(d2 + R, abs(p.z) - T);',
    '  float d = min(max(w.x, w.y), 0.0) + length(max(w, 0.0)) - R;',
    '  return d;',
    '}',
    'vec3 normalAt(vec3 p){',
    '  vec2 e = vec2(1.0, -1.0) * 0.004;',
    '  return normalize(e.xyy * map(p + e.xyy) + e.yyx * map(p + e.yyx) + e.yxy * map(p + e.yxy) + e.xxx * map(p + e.xxx));',
    '}',
    'vec3 env(vec3 d){',
    '  float y = d.y;',
    '  vec3 c = mix(vec3(0.0, 0.01, 0.32), vec3(0.5, 0.53, 1.0), smoothstep(-0.6, 0.8, y));',
    '  c += vec3(1.0) * smoothstep(0.07, 0.0, abs(y - 0.12)) * 0.95;',
    '  c += vec3(1.0) * smoothstep(0.72, 0.95, y) * 1.3;',
    '  c += vec3(0.9, 0.92, 1.0) * smoothstep(0.8, 0.97, abs(d.x)) * smoothstep(0.65, 0.0, abs(y)) * 1.1;',
    '  c += vec3(0.75, 0.78, 1.0) * smoothstep(0.9, 0.99, d.z) * 0.6;',
    '  c *= mix(0.22, 1.0, smoothstep(-0.9, -0.05, y));',
    '  return c;',
    '}',
    'mat3 rotY(float a){ float c = cos(a), s = sin(a); return mat3(c, 0.0, -s, 0.0, 1.0, 0.0, s, 0.0, c); }',
    'mat3 rotX(float a){ float c = cos(a), s = sin(a); return mat3(1.0, 0.0, 0.0, 0.0, c, s, 0.0, -s, c); }',
    'vec4 shade(vec2 uv, float ang){',
    '  mat3 R3 = rotY(ang) * rotX(uTiltX);',
    '  mat3 Ri = rotX(-uTiltX) * rotY(-ang);',
    '  vec3 ro = vec3(0.0, 0.0, 5.4), rd = normalize(vec3(uv, -1.8));',
    '  vec3 c0 = vec3(0.0, uBob - 0.12, 0.0);',
    '  vec3 oc = ro - c0; float b = dot(oc, rd), h = b * b - (dot(oc, oc) - 3.6);',
    '  if (h < 0.0) return vec4(0.0);',
    '  h = sqrt(h); float t = max(-b - h, 0.0), tmax = -b + h;',
    '  vec3 rol = Ri * (ro - vec3(0.0, uBob, 0.0)), rdl = Ri * rd;',
    '  float pa = 1.0 / (uRes.y * 1.8);',
    /* march; remember the ray's closest pass so silhouette pixels get exact coverage */
    '  float best = 1e9, bt = 0.0;',
    '  for (int i = 0; i < 110; i++) {',
    '    vec3 p = rol + rdl * t;',
    '    float d = map(p);',
    '    float k = d / (pa * t);',
    '    if (k < best) { best = k; bt = t; }',
    '    if (d < 0.0004) { best = -1.0; bt = t; break; }',
    '    t += d * 0.75;',
    '    if (t > tmax) break;',
    '  }',
    '  float cov = clamp(0.5 - 0.5 * best, 0.0, 1.0);',
    '  if (cov <= 0.0) return vec4(0.0);',
    '  vec3 p = rol + rdl * bt;',
    '  vec3 n = R3 * normalAt(p);',
    '  vec3 r = reflect(rd, n);',
    '  float fre = pow(1.0 - max(dot(n, -rd), 0.0), 3.0);',
    '  vec3 col = env(r) * mix(vec3(0.82, 0.86, 1.0), vec3(1.06), fre);',
    '  col += pow(max(dot(r, normalize(vec3(0.4, 0.8, 0.5))), 0.0), 60.0) * 1.4;',
    '  col = col / (1.0 + col * 0.3);',
    '  return vec4(col, cov);',
    '}',
    'void main(){',
    '  vec2 uv = (gl_FragCoord.xy - 0.5 * uRes) / uRes.y;',
    '  vec4 acc = shade(uv, uAng);',
    '  gl_FragColor = vec4(acc.rgb * acc.a, acc.a);',
    '}'
  ].join('\n');

  function compile(type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src); gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { console.warn(gl.getShaderInfoLog(s)); return null; }
    return s;
  }
  var vs = compile(gl.VERTEX_SHADER, VS), fs = compile(gl.FRAGMENT_SHADER, FS);
  if (!vs || !fs) return;
  var prog = gl.createProgram();
  gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
  gl.useProgram(prog);

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'a');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

  var tex = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, N, N, 0, gl.LUMINANCE, useHalf ? hf.HALF_FLOAT_OES : gl.UNSIGNED_BYTE, sdf);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

  var U = {};
  ['uRes', 'uEnc', 'uTime', 'uAng', 'uAngVel', 'uTiltX', 'uBob', 'uSdf', 'uS', 'uBend', 'uTwist', 'uMould'].forEach(function (n) { U[n] = gl.getUniformLocation(prog, n); });
  gl.uniform1i(U.uSdf, 0);
  gl.uniform2f(U.uEnc, useHalf ? 0 : 0.5, useHalf ? 1 : 2);

  /* ---- Motion: 8 full turns decelerating to rest at 3.5s, then a gentle hover ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STOP = 3.5, TURNS = Math.PI * 2 * 8;
  function motion(t) {
    if (t < STOP) {
      var k = 1 - t / STOP;
      return { ang: TURNS * (1 - k * k * k), vel: TURNS * 3 * k * k / STOP, tilt: 0, bob: 0 };
    }
    var h = t - STOP, ramp = Math.min(1, h / 1.6);
    ramp = ramp * ramp * (3 - 2 * ramp);
    return {
      ang: TURNS + 0.17 * Math.sin(h * 0.7) * ramp,
      vel: 0,
      tilt: 0.05 * Math.sin(h * 0.55) * ramp,
      bob: 0
    };
  }

  /* ---- Personality once landed: an impact squash, then a looping performance of
     anticipation, stretch, wobbly settle, breathing, leaning and looking around ---- */
  function bump(c, a, b) { return c > a && c < b ? Math.sin(Math.PI * (c - a) / (b - a)) : 0; }
  function body(t) {
    var h = t - STOP;
    if (h <= 0) return { s: 1, bend: 0, twist: 0, mould: 0 };
    var ramp = Math.min(1, h / 1.2); ramp = ramp * ramp * (3 - 2 * ramp);
    var impact = Math.exp(-h * 3.2) * Math.cos(h * 11) * 0.24;
    var P = 4.6, c = (h % P) / P;
    var antic = -0.13 * bump(c, 0.0, 0.14);
    var pop = 0.17 * bump(c, 0.14, 0.3);
    var settle = c > 0.3 ? 0.05 * Math.exp(-(c - 0.3) * 18) * Math.sin((c - 0.3) * 60) : 0;
    var breathe = 0.035 * Math.sin(h * 1.9);
    return {
      s: Math.max(0.7, 1 - impact + ramp * (antic + pop + settle + breathe)),
      bend: ramp * (0.16 * Math.sin(h * 0.85) + 0.06 * Math.sin(h * 2.1 + 1.0) + 0.12 * bump(c, 0.12, 0.34)),
      twist: ramp * (0.34 * Math.sin(h * 0.55) + 0.08 * Math.sin(h * 1.7)),
      mould: ramp * (0.018 + 0.012 * Math.sin(h * 1.3))
    };
  }

  var dpr = Math.min(window.devicePixelRatio || 1, 3);   /* full device resolution: crisp edges */
  function size() {
    var w = canvas.clientWidth, h = canvas.clientHeight;
    if (!w || !h) return;
    dpr = Math.min(window.devicePixelRatio || 1, 3);
    canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
    gl.viewport(0, 0, canvas.width, canvas.height);
    draw(time);
  }

  /* Entrance flight: the canvas's holder travels in from off-screen left,
     bouncing in shrinking hops, and lands in place as the spin stops */
  var host = canvas.parentElement;
  var watch = canvas.closest ? (canvas.closest('.story-head, .mh-story-head') || host) : host;
  var startX = 0, hopAmp = 0;
  function measure() {
    var keep = host.style.transform;
    host.style.transform = '';
    var r = host.getBoundingClientRect();
    host.style.transform = keep;
    startX = -(r.left + r.width * 1.05);
    hopAmp = r.height * 0.5;
  }
  function place(t) {
    if (reduce.matches || t >= STOP) { host.style.transform = ''; return; }
    var u = Math.max(0, t / STOP), e = 1 - Math.pow(1 - u, 3);
    var x = startX * (1 - e);
    var y = -Math.abs(Math.sin(Math.PI * 3 * e)) * hopAmp * Math.pow(1 - e, 1.2);
    host.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
  }

  var time = 0;
  function draw(t) {
    var m = motion(t);
    if (started || reduce.matches) place(t);
    gl.uniform2f(U.uRes, canvas.width, canvas.height);
    gl.uniform1f(U.uTime, t);
    gl.uniform1f(U.uAng, m.ang);
    gl.uniform1f(U.uAngVel, m.vel / 60);
    gl.uniform1f(U.uTiltX, m.tilt);
    gl.uniform1f(U.uBob, m.bob);
    var bd = body(t);
    gl.uniform1f(U.uS, bd.s); gl.uniform1f(U.uBend, bd.bend);
    gl.uniform1f(U.uTwist, bd.twist); gl.uniform1f(U.uMould, bd.mould);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
  }

  var started = false, onScreen = false, running = false, t0 = 0, paused = 0;
  function frame(now) {
    if (!onScreen || document.hidden || reduce.matches) { running = false; paused = now; return; }
    time = (now - t0) / 1000;
    draw(time);
    requestAnimationFrame(frame);
  }
  function start() {
    if (reduce.matches) { time = STOP + 2; draw(time); return; }
    if (running || !onScreen) return;
    var now = performance.now();
    if (!started) { measure(); started = true; t0 = now; }
    else if (paused) { t0 += now - paused; }
    paused = 0;
    running = true; requestAnimationFrame(frame);
  }
  if (window.ResizeObserver) new ResizeObserver(size).observe(canvas);
  else window.addEventListener('resize', size);
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; if (onScreen) start(); }, { threshold: 0.35 }).observe(watch);
  } else { onScreen = true; }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
  if (reduce.addEventListener) reduce.addEventListener('change', start);
  size();
  if (!reduce.matches) { measure(); host.style.transform = 'translate3d(' + startX.toFixed(1) + 'px,0,0)'; }
  start();
  }
  if (window.requestIdleCallback) requestIdleCallback(init, { timeout: 1500 }); else setTimeout(init, 200);
})();
